import { useSearchParams } from "react-router-dom";
import { withLayout } from "../hoc/with-layout";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Typography } from "@mui/material";

export const NotFoundComponent = withLayout(() => {
  const [searchParams] = useSearchParams();
  const message =
    searchParams.get("message") || "The page you’re looking for does not exist";

  return (
    <>
      <StyledCenteredContainer>
        <Typography variant="h2">Oops, something went wrong</Typography>
      </StyledCenteredContainer>
      <StyledCenteredContainer>
        <Typography variant="h5">{message}</Typography>
      </StyledCenteredContainer>
    </>
  );
}, "Not Found");
const StyledCenteredContainer = styled(Grid)(({ theme }) => ({
  justifyContent: "center",
  display: "flex",
  width: "100%",
  marginBottom: theme.spacing(6),
}));
